<template>
<!-- Home de proyecto para elecnor1 (companies.configs.projectHome = 4) -->
<div class="w-full flex flex-col lg:flex-row">
    <div class="w-full lg:hidden containt-tabs-menu">
      <b-tabs ref="refTabsMenu"
        type="is-toggle-rounded"
        v-model="tabSelectedMenu"
        expanded
        class="sticky top-0 mb-3"
        @input="_HandleChangeTab">

        <b-tab-item label="Comentarios"
          value="tab_menu_comments"
          icon="comment-alt"
          icon-pack="fas" class="hidden"></b-tab-item>

        <b-tab-item
          label="Dashboard"
          value="tab_menu_dashboard"
          icon="chart-line"
          icon-pack="fas"></b-tab-item>

      </b-tabs>
    </div>

    <div class="w-full flex flex-row">
      <!-- Columna izquierda: diario de actividad -->
      <div class="w-full lg:w-1/2 lg:mr-2" v-show="showPanel == 'left' || showPanel == 'both'">
        <div class="w-full column-scroll">
          <div class="bg-white border border-grey-light rounded-xl shadow-sm">
            <div class="sticky top-0 z-10 px-4 pt-4 pb-3 bg-white border-b border-grey-lighter rounded-t-xl">
              <h3 class="flex items-center gap-2 mb-3 text-sm font-bold text-blue-darkest">
                <b-icon pack="fas" icon="clock-rotate-left" size="is-small" class="text-blue-dark" />
                {{ $t('home_activity_log_title') }}
              </h3>

              <div class="flex gap-1 p-1 overflow-x-auto bg-grey-lighter rounded-lg">
                <button v-for="tab in activityLogTabs" :key="tab.key"
                  type="button"
                  :class="['flex-1 px-3 py-1.5 text-xs font-semibold whitespace-nowrap rounded-md transition focus:outline-none',
                    activityLog.activeTab === tab.key ? 'bg-white shadow-sm text-blue-darkest' : 'text-grey-darker hover:text-blue-darkest']"
                  @click="activityLog.activeTab = tab.key">
                  {{ tab.label }}
                </button>
              </div>
            </div>

            <!-- Timeline único (diseño nuevo): API en takeoff/notifications; mock en el resto -->
            <div class="px-4 pt-4">
              <div v-if="activityLog.loading" class="pb-4 text-xs text-center text-grey-dark">
                {{ $t('loading') }}…
              </div>
              <ul v-else-if="displayedActivityLog.length">
                <li v-for="(entry, i) in displayedActivityLog" :key="entry.id" class="flex gap-3">
                  <div class="flex flex-col items-center">
                    <span :class="['flex items-center justify-center flex-shrink-0 w-8 h-8 rounded-full text-xs font-bold', avatarColor(entry.user)]">
                      {{ initials(entry.user.name) }}
                    </span>
                    <span class="flex-1 w-px my-1 bg-grey-light" />
                    <b-icon pack="fas" size="is-small"
                      :icon="activityLogIcon(entry).icon"
                      :class="['my-1', activityLogIcon(entry).color]" />
                    <span v-if="i < displayedActivityLog.length - 1" class="flex-1 w-px mt-1 bg-grey-light" />
                  </div>

                  <div class="min-w-0 pb-5">
                    <div class="text-xs">
                      <span class="font-bold text-blue-darkest">{{ entry.user.name }}</span>
                      <span v-if="entry.user.role" class="text-grey-dark">· {{ entry.user.role }}</span>
                    </div>
                    <div class="text-xs text-grey-darkest">{{ entry.message }}</div>
                    <div v-if="entry.subtitle" class="text-sm uppercase text-blue-darkest">{{ entry.subtitle }}</div>
                    <div v-if="entry.filename" class="flex items-center gap-1 mt-1 text-xs font-mono text-grey-dark">
                      <b-icon pack="fas" icon="paperclip" size="is-small" />
                      <span class="truncate">{{ entry.filename }}</span>
                    </div>
                    <div class="text-xs text-grey-dark mt-1">{{ activityLogWhen(entry.date) }}</div>
                  </div>
                </li>
              </ul>
              <p v-else class="pb-4 text-xs text-center text-grey-dark">{{ $t('home_activity_log_empty') }}</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Columna derecha -->
      <div class="w-full lg:w-1/2 lg:ml-2" v-show="showPanel == 'right' || showPanel == 'both'">
        <div class="w-full column-scroll">

          <!-- Accesos a dashboards + KPIs -->
          <div v-if="dashboardCards.length" class="grid grid-cols-1 sm:grid-cols-2 gap-3 my-4">
            <button v-for="(card, i) in dashboardCards" :key="'btn_dash' + i"
              type="button"
              class="flex flex-col items-center justify-center gap-2 px-4 py-5 bg-white border border-grey-light rounded-lg cursor-pointer transition hover:border-blue-light hover:shadow-md focus:outline-none"
              @click="card.action">
              <b-icon pack="fas" :icon="card.icon" :class="card.color" />
              <span class="text-sm font-bold text-blue-darkest">{{ $t(card.text) }}</span>
            </button>
          </div>

          <div class="flex flex-col gap-4 my-4">
            <!-- Avance físico -->
            <div class="bg-white border border-grey-light rounded-xl shadow-sm p-5">
              <div class="flex items-start justify-between gap-3 mb-3">
                <div>
                  <h3 class="text-sm font-bold uppercase tracking-wide text-blue-darkest">{{ $t('home_summary_physical_progress') }}</h3>
                  <p class="text-xs text-grey-darker mt-1">{{ $t('home_summary_physical_progress_subtitle') }}</p>
                </div>
                <span v-if="physicalDeviation !== null" :class="['text-xs font-bold px-2 py-1 rounded whitespace-nowrap',
                  physicalDeviation < 0 ? 'bg-red-lightest text-red-dark' : 'bg-green-lightest text-green-dark']">
                  {{ fmtPercent(physicalDeviation, 1, { signDisplay: 'exceptZero' }) }}
                </span>
              </div>

              <div class="flex items-baseline gap-2 mb-3">
                <span class="text-4xl font-bold text-blue-darkest leading-none">{{ fmtPercent(summary.physicalProgress.real) }}</span>
                <span class="text-sm text-grey-darker">{{ $t('home_summary_real') }}</span>
              </div>

              <div class="relative w-full h-2.5 rounded-full bg-grey-lighter overflow-hidden">
                <div class="absolute inset-y-0 left-0 rounded-full bg-grey-light" :style="barWidth(summary.physicalProgress.planned)" />
                <div class="absolute inset-y-0 left-0 rounded-full bg-blue-dark" :style="barWidth(summary.physicalProgress.real)" />
              </div>
              <div class="flex justify-between mt-2 text-xs text-grey-darker">
                <span>{{ fmtPercent(0, 0) }}</span>
                <span class="font-bold text-blue-darkest">{{ $t('plan') }}: {{ fmtPercent(summary.physicalProgress.planned) }}</span>
                <span>{{ fmtPercent(100, 0) }}</span>
              </div>
            </div>

            <!-- Valor ganado -->
            <div class="bg-white border border-grey-light rounded-xl shadow-sm p-5">
              <div class="flex items-start justify-between gap-3 mb-3">
                <div>
                  <h3 class="text-sm font-bold uppercase tracking-wide text-blue-darkest">{{ $t('earned_value') }}</h3>
                  <p class="text-xs text-grey-darker mt-1">{{ $t('home_summary_earned_value_subtitle') }}</p>
                </div>
                <span v-if="spi !== null" :class="['text-xs font-bold px-2 py-1 rounded whitespace-nowrap',
                  spi < 1 ? 'bg-red-lightest text-red-dark' : 'bg-green-lightest text-green-dark']">
                  SPI: {{ fmtNumber(spi, 2) }}
                </span>
              </div>

              <div class="flex items-baseline gap-2 mb-3">
                <span class="text-4xl font-bold text-blue-darkest leading-none">{{ fmtCurrency(summary.earnedValue.ev) }}</span>
                <span class="text-sm text-grey-darker">EV</span>
              </div>

              <div class="relative w-full h-2.5 rounded-full bg-grey-lighter overflow-hidden">
                <div class="absolute inset-y-0 left-0 rounded-full bg-grey-light" :style="barWidth(percentOf(summary.earnedValue.pv, summary.earnedValue.bac))" />
                <div class="absolute inset-y-0 left-0 rounded-full bg-orange-dark" :style="barWidth(percentOf(summary.earnedValue.ev, summary.earnedValue.bac))" />
              </div>
              <div class="flex justify-between mt-2 text-xs text-grey-darker">
                <span>PV: {{ fmtCurrency(summary.earnedValue.pv) }}</span>
                <span>BAC: {{ fmtCurrency(summary.earnedValue.bac) }}</span>
              </div>
            </div>

            <!-- Fuerza de ejecución -->
            <div class="bg-white border border-grey-light rounded-xl shadow-sm p-5">
              <div class="flex items-start justify-between gap-3 mb-3">
                <div>
                  <h3 class="text-sm font-bold uppercase tracking-wide text-blue-darkest">{{ $t('home_summary_execution_force') }}</h3>
                  <p class="text-xs text-grey-darker mt-1">{{ $t('home_summary_execution_force_subtitle') }}</p>
                </div>
                <span v-if="summary.executionForce.badge"
                  class="text-xs font-bold px-2 py-1 rounded whitespace-nowrap bg-purple-lightest text-purple-dark">
                  {{ summary.executionForce.badge }}
                </span>
              </div>

              <div class="grid grid-cols-2 gap-4">
                <div>
                  <div class="text-4xl font-bold text-blue-darkest leading-none">{{ fmtNumber(summary.executionForce.activeStaff) }}</div>
                  <div class="flex items-center gap-1 mt-2 text-xs text-grey-darker">
                    <b-icon pack="fas" icon="user-group" size="is-small" />
                    {{ $t('home_summary_active_staff') }}
                  </div>
                </div>
                <div>
                  <div class="text-4xl font-bold text-blue-darkest leading-none">{{ fmtNumber(summary.executionForce.tasksInProgress) }}</div>
                  <div class="flex items-center gap-1 mt-2 text-xs text-grey-darker">
                    <b-icon pack="fas" icon="wave-square" size="is-small" />
                    {{ $t('home_summary_tasks_in_progress') }}
                  </div>
                </div>
              </div>

              <div class="flex items-center justify-between mt-4 pt-3 border-t border-grey-lighter text-xs text-grey-darker">
                <span>{{ $t('home_summary_status_distribution') }}</span>
                <div class="flex items-center gap-3">
                  <span v-for="status in summary.executionForce.statusDistribution" :key="status.label"
                    class="flex items-center gap-1"
                    :title="$t(status.label)">
                    <span :class="['w-2 h-2 rounded-full', status.color]" />
                    {{ fmtNumber(status.count) }}
                  </span>
                </div>
              </div>
            </div>

            <!-- Focos de atención operativa -->
            <div class="bg-white border border-grey-light rounded-xl shadow-sm overflow-hidden">
              <h3 class="flex items-center gap-2 px-5 py-4 border-b border-grey-lighter text-sm font-bold text-blue-darkest">
                <b-icon pack="fas" icon="triangle-exclamation" size="is-small" class="text-red-dark" />
                {{ $t('home_summary_operational_focus') }}
              </h3>

              <div v-if="!summary.operationalFocus.length" class="px-5 py-6 text-xs text-center text-grey-dark">
                {{ $t('no_results') }}
              </div>
              <div v-else class="overflow-x-auto">
                <table class="w-full text-xs">
                  <thead>
                    <tr class="border-b border-grey-lighter text-grey-dark uppercase tracking-wide">
                      <th class="px-5 py-3 text-left font-semibold">{{ $t('home_summary_activity_kks') }}</th>
                      <th class="px-3 py-3 text-left font-semibold">{{ $t('home_summary_alert') }}</th>
                      <th class="px-3 py-3 text-right font-semibold whitespace-nowrap">{{ $t('home_summary_plan_vs_real') }}</th>
                      <th class="px-5 py-3 text-right font-semibold">{{ $t('home_summary_float') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(activity, i) in summary.operationalFocus" :key="activity.id || (activity.code + '_' + i)"
                      :class="{ 'border-b border-grey-lighter': i < summary.operationalFocus.length - 1 }">
                      <td class="px-5 py-3">
                        <div class="font-bold uppercase text-blue-darkest">{{ activity.name }}</div>
                        <div class="font-mono text-grey-dark mt-1">{{ activity.code || '—' }}</div>
                      </td>

                      <td class="px-3 py-3">
                        <span v-if="FOCUS_ALERTS[activity.alert]"
                          :class="['inline-flex items-center gap-1 px-2 py-1 rounded font-bold whitespace-nowrap', FOCUS_ALERTS[activity.alert].classes]">
                          <b-icon pack="fas" :icon="FOCUS_ALERTS[activity.alert].icon" size="is-small" />
                          {{ $t(FOCUS_ALERTS[activity.alert].label) }}
                        </span>
                        <span v-else class="text-grey-dark">—</span>
                      </td>

                      <td class="px-3 py-3">
                        <div class="flex items-center justify-end gap-2">
                          <span class="text-grey-darker">{{ fmtPercent(activity.planned, 0) }}</span>
                          <div class="relative w-12 h-1.5 rounded-full bg-grey-lighter overflow-hidden">
                            <div class="absolute inset-y-0 left-0 rounded-full bg-grey-light" :style="barWidth(activity.planned)" />
                            <div :class="['absolute inset-y-0 left-0 rounded-full', (activity.real || 0) < (activity.planned || 0) ? 'bg-red' : 'bg-green']"
                              :style="barWidth(activity.real)" />
                          </div>
                          <span class="w-8 text-right font-bold text-blue-darkest">{{ fmtPercent(activity.real, 0) }}</span>
                        </div>
                      </td>

                      <td :class="['px-5 py-3 text-right font-bold whitespace-nowrap', floatColor(activity.float)]">
                        {{ activity.float === null || activity.float === undefined ? '—' : $t('home_summary_days_short', { count: activity.float }) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <!-- Perfil de avance + Top actividades por peso -->
            <div class="bg-white border border-grey-light rounded-xl shadow-sm p-5">
              <h3 class="mb-3 text-sm font-bold text-blue-darkest">{{ $t('home_summary_progress_profile') }}</h3>

              <div class="flex flex-col gap-3">
                <div v-for="range in summary.progressProfile.ranges" :key="range.from + '_' + range.to">
                  <div class="flex items-center justify-between mb-1 text-xs">
                    <span class="text-grey-darker">{{ $t('home_summary_range_completed', { from: range.from, to: range.to }) }}</span>
                    <span class="font-bold text-blue-darkest">{{ fmtNumber(range.count) }}</span>
                  </div>
                  <div class="relative w-full h-1.5 rounded-full bg-grey-lighter overflow-hidden">
                    <div class="absolute inset-y-0 left-0 rounded-full bg-blue-dark" :style="barWidth(percentOf(range.count, maxRangeCount))" />
                  </div>
                </div>
              </div>

              <div class="mt-5 pt-4 border-t border-grey-lighter">
                <h4 class="mb-3 text-sm font-bold text-blue-darkest">{{ $t('home_summary_top_activities_by_weight') }}</h4>

                <div class="flex flex-col gap-3">
                  <div v-for="(activity, i) in summary.progressProfile.topActivities" :key="'top_' + i"
                    class="flex items-center justify-between gap-4">
                    <div class="min-w-0">
                      <div class="max-w-xs truncate text-xs font-bold uppercase text-blue-darkest" :title="activity.name">
                        {{ activity.name }}
                      </div>
                      <div class="font-mono text-xs text-grey-dark mt-1">{{ fmtCurrency(activity.amount) }}</div>
                    </div>
                    <span class="text-sm font-bold text-green-dark">{{ fmtPercent(activity.progress, 0) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- PANEL DE FILTROS -->
          <div class="panel">
            <project-notifications-filter
              :project-id="project ? project.id : 0"
              @reload-notifications="reloadNotifications"
            />
          </div>

          <div v-if="project && project.can_admin" class="panel">
              <project-assignments-preview />
          </div>

          <div class="panel">
            <project-activities-preview />
          </div>

          <div v-if="project && project.can_admin && project.id != 580" class="panel"><!-- cuadro ocultado temporalmente al projecto 580 por necesidad de Jose -->
              <project-economic-preview />
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import moment from 'moment'
import projectNotificationsFilter from '·/components/project-notifications-filter'
import projectActivitiesPreview from '·/components/project-activities-preview'
import projectEconomicPreview from '·/components/project-economic-preview'
import projectAssignmentsPreview from '·/components/project-assignments-preview'

// Icono (Font Awesome 6) y color (paleta tailwind.config.js) de cada tarjeta según el suffix_route del dashboard
const DASHBOARD_CARD_ICONS = {
  default: { icon: 'table-cells-large', color: 'text-blue' },
  report: { icon: 'file-lines', color: 'text-green-dark' },
  photovoltaic: { icon: 'object-group', color: 'text-purple-dark' },
  documents: { icon: 'folder-open', color: 'text-teal-dark' },
  prm: { icon: 'coins', color: 'text-indigo' },
  performance: { icon: 'gauge-high', color: 'text-pink-dark' },
}

const ACTIVITY_LOG_TYPES = {
  p6: { icon: 'calendar-days', color: 'text-blue-dark' },
  takeoff: { icon: 'file-lines', color: 'text-green-dark' },
  hh: { icon: 'user-group', color: 'text-purple-dark' },
  budget: { icon: 'coins', color: 'text-orange-dark' },
  notifications: { icon: 'bell', color: 'text-blue-dark' },
}

// Motivos de selección del dashboard performance (reasons)
const FOCUS_ALERTS = {
  critical_path: { label: 'performance_dashboard_reason_critical_path', icon: 'diamond', classes: 'bg-red-lightest text-red-dark' },
  weight: { label: 'performance_dashboard_col_weight', icon: 'weight-hanging', classes: 'bg-orange-lightest text-orange-dark' },
  cost_deviation: { label: 'deviation', icon: 'arrow-trend-down', classes: 'bg-red-lightest text-red-dark' },
}

const AVATAR_COLORS = [
  'bg-purple-lightest text-purple-dark',
  'bg-green-lightest text-green-dark',
  'bg-blue-lightest text-blue-dark',
  'bg-orange-lightest text-orange-dark',
  'bg-teal-lightest text-teal-dark',
  'bg-pink-lightest text-pink-dark',
]

const daysAgoAt = (days, hour, minute) =>
  moment().subtract(days, 'days').hour(hour).minute(minute).toISOString()

const MOCK_USERS = {
  david: { id: 1, name: 'David P.', role: 'Supervisor' },
  laura: { id: 2, name: 'Laura M.', role: 'Planificador' },
  carlos: { id: 3, name: 'Carlos T.', role: 'Gerente' },
  elena: { id: 4, name: 'Elena R.', role: 'Ingeniero' },
}

export default {
  middleware: 'auth',
  title: 'project_home_page_title',
  subtitle: 'project_home_page_subtitle',
  menuOption: '2-1',

  components: {
    projectNotificationsFilter,
    projectActivitiesPreview,
    projectEconomicPreview,
    projectAssignmentsPreview,
  },

  data: () => ({
    ACTIVITY_LOG_TYPES,
    FOCUS_ALERTS,

    showPanelRight: true,
    showPanelLeft: true,

    tabSelectedMenu: -1, // tab seleccionado por defecto
    activityLogFilters: null,

    activityLog: {
      activeTab: 'all',
      loading: false,
      // Entradas de la API (takeoff / notifications) mapeadas al timeline
      apiEntries: [],
      // TODO: mock temporal para tabs sin API aún (p6 / hh / budget)
      mockEntries: [
        { id: 1, user: MOCK_USERS.david, type: 'hh', messageKey: 'home_activity_log_assigned_supervisor', subtitle: 'Foundation execution - Potable water tank (recirculation pump)', date: daysAgoAt(3, 18, 30) },
        { id: 3, user: MOCK_USERS.carlos, type: 'p6', messageKey: 'home_activity_log_updated_p6_schedule', subtitle: 'Foundation execution - Desmineralized water tank A', date: daysAgoAt(2, 10, 4) },
        { id: 4, user: MOCK_USERS.elena, type: 'budget', messageKey: 'home_activity_log_uploaded_budget', subtitle: 'Foundation execution - Compressed air vessels', date: daysAgoAt(2, 11, 51) },
        { id: 5, user: MOCK_USERS.david, type: 'hh', messageKey: 'home_activity_log_updated_hh_planning', subtitle: 'Foundation execution - Air compressors and dreyers', date: daysAgoAt(2, 12, 38) },
        { id: 7, user: MOCK_USERS.carlos, type: 'p6', messageKey: 'home_activity_log_uploaded_p6_update', subtitle: 'Foundation execution - Water treatment chemical feed area (WTP dosing)', date: daysAgoAt(2, 14, 12) },
        { id: 8, user: MOCK_USERS.elena, type: 'budget', messageKey: 'home_activity_log_updated_budget_link', subtitle: 'Foundation execution - Basin chemical dosing (WWTP) and HRSG dosing', date: daysAgoAt(2, 15, 59) },
        { id: 9, user: MOCK_USERS.david, type: 'hh', messageKey: 'home_activity_log_assigned_supervisor', subtitle: 'Foundation execution - Sanitary treatment system', date: daysAgoAt(2, 16, 46) },
      ],
    },

    // TODO: datos ficticios salvo physicalProgress / earnedValue / operationalFocus (GET project/{id}/home-summary)
    summary: {
      // Proyecto completo: real = avance actual de los grupos raíz, planned = programado a hoy (fechas current_*)
      physicalProgress: { real: null, planned: null },
      // EV = Σ (avance × budget), PV = Σ (programado × budget), BAC = Σ budget (grupos raíz)
      earnedValue: { ev: null, pv: null, bac: null },
      executionForce: {
        activeStaff: 144,
        tasksInProgress: 24,
        badge: '',
        statusDistribution: [
          { label: 'completed', count: 5, color: 'bg-green' },
          { label: 'activity_status_running', count: 22, color: 'bg-blue' },
          { label: 'pending', count: 0, color: 'bg-grey' },
        ],
      },
      // Mismas actividades del dashboard performance (vista previa)
      operationalFocus: [],
      progressProfile: {
        ranges: [
          { from: 0, to: 25, count: 0 },
          { from: 26, to: 50, count: 6 },
          { from: 51, to: 75, count: 10 },
          { from: 76, to: 99, count: 6 },
        ],
        topActivities: [
          { name: 'Fire and gas conduits assembly - Area 08', amount: 1850000, progress: 72 },
          { name: 'Instrumentation junction boxes installation', amount: 720000, progress: 51 },
          { name: 'Foundation execution - Pipeway overpass stair', amount: 605000, progress: 85 },
          { name: 'Foundation execution - Waste water tank', amount: 605000, progress: 100 },
          { name: 'Foundation execution - Desmineralized water tank', amount: 605000, progress: 30 },
        ],
      },
    },
  }),

  computed: {
    ...mapGetters({
      user: 'auth/user',
      project: 'app/project',
      company: 'app/company',
      mobile: 'device/mobile',
    }),

    showPanel() {
      if (!this.mobile.on_mobile) return 'both'
      return this.showPanelRight ? 'right' : 'left'
    },

    canSeeNotifications() {
      const p = this.project
      if (!p) return false
      return p.issue_template
        ? p.can_admin || p.can_participate || p.can_view || p.can_issue_admin || p.can_issue_resolutor || p.can_collaborate
        : p.can_admin || p.can_participate || p.can_view
    },

    showBtnKPI() {
      return !!this.project && (this.project.can_admin || this.project.can_progress);
    },

    dashboardCards() {
      const cards = this.GetBtnDashboard().map(btn => ({
        text: btn.text,
        ...(DASHBOARD_CARD_ICONS[btn.suffix_route] || DASHBOARD_CARD_ICONS.default),
        action: () => this.$router.push({ name: 'project.dashboard.' + btn.suffix_route }),
      }))

      if (this.showBtnKPI) {
        cards.push({ text: 'kpis', icon: 'chart-column', color: 'text-orange-dark', action: this.goToKpi })
      }

      return cards
    },

    activityLogTabs() {
      return [
        { key: 'all', label: this.$t('all') },
        { key: 'p6', label: 'P6' },
        { key: 'takeoff', label: this.$t('takeoff') },
        { key: 'hh', label: this.$t('home_activity_log_hh_management') },
        { key: 'budget', label: this.$t('budget') },
        { key: 'notifications', label: this.$t('notifications') },
      ]
    },

    // takeoff / notifications → API; resto → mock hasta cablear
    activityLogUsesApi() {
      return ['takeoff', 'notifications'].includes(this.activityLog.activeTab)
    },

    displayedActivityLog() {
      if (this.activityLogUsesApi) {
        return this.activityLog.apiEntries
      }
      const { activeTab, mockEntries } = this.activityLog
      const rows = activeTab === 'all'
        ? mockEntries
        : mockEntries.filter(entry => entry.type === activeTab)
      return rows.map(entry => ({
        ...entry,
        message: entry.messageKey ? this.$t(entry.messageKey) : (entry.message || ''),
      }))
    },

    physicalDeviation() {
      const { real, planned } = this.summary.physicalProgress
      return real === null || planned === null ? null : real - planned
    },

    spi() {
      const { ev, pv } = this.summary.earnedValue
      if (ev === null || pv === null || !pv) return null
      return ev / pv
    },

    maxRangeCount() {
      return Math.max(0, ...this.summary.progressProfile.ranges.map(range => range.count || 0))
    },
  },

  watch: {
    // En móvil se muestra un solo panel (por defecto el derecho, tab "Dashboard"); en escritorio ambos
    'mobile.on_mobile': {
      immediate: true,
      handler(onMobile) {
        if (onMobile) {
          this.tabSelectedMenu = 1
          this.showPanelLeft = false
          this.showPanelRight = true
        } else {
          this.showPanelLeft = true
          this.showPanelRight = true
        }
      },
    },

    'activityLog.activeTab'() {
      this.loadActivityLog()
    },
  },

  mounted() {
    if (this.project == null) {
      this.$router.push('/projects');
    } else {
      let pageInfo = {
        title: this.project.name,
        subtitle: this.$t('project_home_page_subtitle'),
        menuOption: '2-1',
      }

      this.$store.dispatch('app/updatePageInfo', {info: pageInfo})
      this.loadSummary()
      this.loadActivityLog()
    }
  },

  methods: {
    async loadSummary() {
      try {
        const { data } = await axios.get(`/api/v2/project/${this.project.id}/home-summary`)
        const payload = data && data.success ? data.data : null
        if (payload && payload.physical_progress) {
          this.summary.physicalProgress = {
            real: payload.physical_progress.real,
            planned: payload.physical_progress.planned,
          }
        }
        if (payload && payload.earned_value) {
          this.summary.earnedValue = {
            ev: payload.earned_value.ev,
            pv: payload.earned_value.pv,
            bac: payload.earned_value.bac,
          }
        }
        if (payload && Array.isArray(payload.operational_focus)) {
          this.summary.operationalFocus = payload.operational_focus
        }
      } catch (error) {
        this.$notify.error('error_loading_data')
      }
    },

    async loadActivityLog() {
      if (!this.project || !this.activityLogUsesApi || !this.canSeeNotifications) {
        this.activityLog.apiEntries = []
        return
      }

      this.activityLog.loading = true
      try {
        const tab = this.activityLog.activeTab
        const params = {
          page: 1,
          // takeoff: solo las del usuario (rápido). Historial completo (show_all) es muy pesado.
          show_all: false,
        }
        if (tab === 'takeoff') {
          params.type = 'takeoff'
        }
        if (this.activityLogFilters) {
          params.filters = this.activityLogFilters
        }

        const { data } = await axios.get(`/api/v2/user/notifications/project/${this.project.id}`, { params })
        const list = data && data.success ? (data.notifications || []) : []
        this.activityLog.apiEntries = list.map(item => this.mapNotificationToLogEntry(item))
      } catch (error) {
        this.activityLog.apiEntries = []
        this.$notify.error('error_loading_data')
      } finally {
        this.activityLog.loading = false
      }
    },

    // Mapea cualquier notificación al timeline (sin componentes por tipo).
    // Si es import (filename / takeoff_import_id), muestra el archivo.
    mapNotificationToLogEntry(item) {
      const d = item.data || {}
      const logType = d.log_type || this.guessLogType(d.type || item.type)
      const name = d.creator_name || d.activity_document_user_name || d.notification_title || '—'
      return {
        id: item.id,
        type: logType,
        user: { id: d.creator_id || d.executor_user_id || name, name },
        message: d.notification_message || d.notification_title || '',
        subtitle: d.activity_name || d.activity_project_name || null,
        filename: d.filename || null,
        date: item.created_at,
      }
    },

    guessLogType(type) {
      const name = String(type || '').split('\\').pop()
      if (name === 'TakeoffImported' || (name && name.includes('Takeoff'))) return 'takeoff'
      if (name && name.includes('Document')) return 'takeoff'
      return 'notifications'
    },

    activityLogIcon(entry) {
      return ACTIVITY_LOG_TYPES[entry.type] || { icon: 'bell', color: 'text-blue-dark' }
    },

    reloadNotifications(filters) {
      this.activityLogFilters = filters
      if (this.activityLogUsesApi) {
        this.loadActivityLog()
      }
    },

    _HandleChangeTab(value) {
      // value contiene el index del tab pulsado siendo
      // 0= el primero tab que corresponde a al menu comments panel comentarios
      // 1= el segundo tab que corresponde al menu dasboard panel derecho

      if (this.mobile.on_mobile) {
        this.showPanelRight = value === 1
        this.showPanelLeft = value === 0
      }
    },

    GetBtnDashboard() {
        const btns = this.project && this.project.configs && this.project.configs.dashboards
          ? this.project.configs.dashboards.filter(btn => btn.visible)
          : []
        return btns
    },

    goToKpi() {
      this.$router.push({ name: 'project.admin.kpi', params: { project_id: this.project.id } });
    },

    fmtNumber(value, decimals = 0, options = {}) {
      return new Intl.NumberFormat(this.$i18n.locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        ...options,
      }).format(value || 0)
    },

    fmtPercent(value, decimals = 1, options = {}) {
      if (value === null || value === undefined) return '—'
      return this.fmtNumber(value, decimals, options) + '%'
    },

    fmtCurrency(value, currency = 'EUR') {
      if (value === null || value === undefined) return '—'
      return new Intl.NumberFormat(this.$i18n.locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: 0,
      }).format(value)
    },

    percentOf(value, total) {
      if (value === null || value === undefined || !total) return 0
      return (value / total) * 100
    },

    barWidth(percent) {
      return { width: Math.min(Math.max(percent || 0, 0), 100) + '%' }
    },

    floatColor(days) {
      if (days === null || days === undefined) return 'text-grey-dark'
      if (days <= 0) return 'text-red-dark'
      if (days <= 2) return 'text-orange-dark'
      return 'text-green-dark'
    },

    initials(name) {
      return (name || '')
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map(word => word[0].toUpperCase())
        .join('')
    },

    avatarColor(user) {
      const seed = user.id || this.initials(user.name).charCodeAt(0) || 0
      return AVATAR_COLORS[seed % AVATAR_COLORS.length]
    },

    activityLogWhen(date) {
      const when = moment(date).locale(this.$i18n.locale)
      const relative = when.fromNow()
      return relative.charAt(0).toUpperCase() + relative.slice(1) + ' ' + when.format('HH:mm')
    },
  },

};
</script>

<style scoped>
.containt-tabs-menu::v-deep .b-tabs section {
  display: none;
}

.column-scroll {
  height: calc(100vh - 150px);
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
